import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start" }
const _hoisted_2 = { class: "flex-shrink-0" }
const _hoisted_3 = { class: "ml-3 w-0 flex-1" }
const _hoisted_4 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_5 = { class: "mt-1 text-sm text-gray-500" }

import { ref, onMounted } from "vue";
import type { NotificationProps } from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationToast',
  props: {
    type: {},
    message: {},
    duration: { default: 3000 },
    offsetIndex: { default: 0 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = ref(false);

onMounted(() => {
  visible.value = true;

  setTimeout(() => {
    close();
  }, props.duration);
});

function close() {
  visible.value = false;
  setTimeout(() => {
    emit("close");
  }, 500);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "enter-from-class": "opacity-0 transform translate-y-2 scale-95",
    "enter-to-class": "opacity-100 transform translate-y-0 scale-100",
    "leave-active-class": "transition-all duration-200 ease-in",
    "leave-from-class": "opacity-100 transform translate-y-0 scale-100",
    "leave-to-class": "opacity-0 transform translate-y-2 scale-95"
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({
        top: (96 + (props.offsetIndex || 0) * 80) + 'px',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
      }),
            class: _normalizeClass([
        'fixed right-4 z-[9999] max-w-sm w-full',
        'bg-white rounded-lg shadow-lg border-l-4 p-4',
        _ctx.type === 'success' ? 'border-green-500' : _ctx.type === 'warning' ? 'border-yellow-500' : _ctx.type === 'modifier' ? 'border-blue-500' : 'border-red-500',
      ])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass([
              'w-6 h-6 rounded-full flex items-center justify-center text-white',
              _ctx.type === 'success' ? 'bg-green-500' : _ctx.type === 'warning' ? 'bg-yellow-500' : _ctx.type === 'modifier' ? 'bg-blue-500' : 'bg-red-500',
            ])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([
                _ctx.type === 'success' ? 'fas fa-check' : _ctx.type === 'warning' ? 'fas fa-exclamation-triangle' : _ctx.type === 'modifier' ? 'fas fa-pencil-alt' : 'fas fa-exclamation'
              , "text-xs"])
                  }, null, 2)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.type === "success"
                ? "Sauvegardé avec succès !"
                : _ctx.type === "warning"
                ? "Avertissement"
                : _ctx.type === "modifier"
                ? "Modification"
                : "Erreur lors de la sauvegarde"), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.message), 1)
              ]),
              _createElementVNode("div", { class: "ml-4 flex-shrink-0 flex" }, [
                _createElementVNode("button", {
                  onClick: close,
                  class: "bg-white rounded-md inline-flex text-gray-400 hover:text-gray-600 focus:outline-none"
                }, " × ")
              ])
            ])
          ], 6))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})